<template>
    <b-row>
        <div class="col-sm-12 mt-3">
            <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                <thead>
                    <tr>
                        <th style="width: 20%;text-align: center;">
                            Suscursal
                        </th>
                        <th style="width: 10%;text-align: center;">
                            Fecha
                        </th>
                        <th style="width: 60%;">
                            Comentario
                        </th>
                        <th style="width: 10%;text-align: center;">
                            ...
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in registros" :key="index">
                        <td style="text-align: center;">
                            {{ convertir_codigo_a_sucursal(item.sucursal) }}
                        </td>
                        <td style="text-align: center;">
                            {{ item.fecha }}
                        </td>
                        <td>
                            {{ item.comentarios }}
                        </td>
                        <td style="text-align: center;">
                            <button type="button" style="font-size: 9px;" class="btn btn-sm btn-outline-dark"
                                @click="abrir_modal_detalle(item)"><i class="fas fa-eye"></i></button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <DetalleRechazadas v-if="modal_detalle_rechazadas" :item="detalle" v-on:salir="cerrar_modal_detalle_rechadas" />
    </b-row>
</template>

<script>
    import { mapActions, mapState } from 'vuex'
    import DetalleRechazadas from './DetalleSolicitud.vue'

    export default {
        name: 'Rechazados',
        computed: {
            ...mapState(['id_empresa_seleccionada', 'datos_usuario', 'sucursales'])
        },
        components: {
            DetalleRechazadas
        },
        data() {
            return {
                registros: [],
                modal_detalle_rechazadas: false,
                detalle: {}
            }
        },
        methods: {
            async obtener_solicitudes() {
                let f = {
                    api: `solicitud-descuentos?filters[empresa][$eq][0]=${this.id_empresa_seleccionada}&filters[estado][$eq][1]=RECHAZADO`
                }

                let r = await this.obtener_data(f)
                this.registros = r
            },
            convertir_codigo_a_sucursal(codigo) {
                if (codigo == null || codigo == '' || codigo == undefined) {
                    return 'N/A'
                } else {

                    let i = this.sucursales.findIndex(item => item.codigo == codigo)
                    return this.sucursales[i].nombre
                }
            },
            abrir_modal_detalle(item) {
                this.detalle = item
                this.modal_detalle_rechazadas = true
            },
            cerrar_modal_detalle_rechadas() {
                this.modal_detalle_rechazadas = false
            },
            ...mapActions(['obtener_data']),
        },
        mounted() {
            this.obtener_solicitudes()
        },
    }
</script>

<style></style>